import { render, staticRenderFns } from "./GhostLab.vue?vue&type=template&id=5966b83f&scoped=true"
import script from "./GhostLab.vue?vue&type=script&lang=js"
export * from "./GhostLab.vue?vue&type=script&lang=js"
import style0 from "./GhostLab.vue?vue&type=style&index=0&id=5966b83f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5966b83f",
  null
  
)

export default component.exports